import { AssetStatus } from '@risksmart-app/domain/src/types/consts/asset-status';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import type { FilterModal } from '@/components/customisable-ribbon/customisableRibbonModalSchema';

export const useGetDefaultRibbonFilters = (): FilterModal[] => {
  const { t } = useTranslation(['common'], {
    keyPrefix: 'assets.dashboard',
  });

  return useMemo(
    () => [
      {
        id: uuidv4(),
        title: t('active'),
        itemFilterQuery: {
          tokens: [],
          tokenGroups: [
            {
              value: AssetStatus.Active,
              propertyKey: 'StatusLabelled',
              operator: '=',
            },
          ],
          operation: 'and',
        },
      },
      {
        id: uuidv4(),
        title: t('retired'),
        itemFilterQuery: {
          tokens: [],
          tokenGroups: [
            {
              value: AssetStatus.Retired,
              propertyKey: 'StatusLabelled',
              operator: '=',
            },
          ],
          operation: 'and',
        },
      },
      {
        id: uuidv4(),
        title: t('disposed'),
        itemFilterQuery: {
          tokens: [],
          tokenGroups: [
            {
              value: AssetStatus.Disposed,
              propertyKey: 'StatusLabelled',
              operator: '=',
            },
          ],
          operation: 'and',
        },
      },
      {
        id: uuidv4(),
        title: t('all'),
        itemFilterQuery: {
          tokens: [],
          tokenGroups: [],
          operation: 'and',
        },
      },
    ],
    [t]
  );
};
